import {FC} from "react"

import {useTranslation} from "@frontend/i18n"
import {css} from "@styled-system/css"
import {hstack} from "@styled-system/patterns"

interface MultipleChoiceOptionsProps {
  options: string[]
  onChooseOption: (option: string) => void
  disabled?: boolean
}

export const MultipleChoiceOptions: FC<MultipleChoiceOptionsProps> = ({
  options,
  onChooseOption,
  disabled = false,
}) => {
  const t = useTranslation()
  return (
    <>
      <span
        className={css({
          color: "text.tertiary",
          textStyle: "captionRegular",
        })}
      >
        {t("conversation.quickResponses")}
      </span>
      <div className={hstack({justifyContent: "right"})}>
        <div
          className={css({
            display: "flex",
            flexDirection: "row",
            gap: 8,
            flexWrap: "wrap",
            justifyContent: "flex-end",
          })}
        >
          {options.map((option) => (
            <button
              className={css({
                borderRadius: "24px 24px 4px 24px",
                borderWidth: 2,
                borderColor: disabled ? "border.secondary" : "border.brand.primary",
                color: disabled ? "text.tertiary" : "text.brand.primary",
                paddingY: 10,
                paddingX: 16,
                backgroundColor: disabled
                  ? "background.secondary"
                  : "background.brand.primarySubtle",
                textStyle: "bodyLargeMedium",
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.9 : 1,
              })}
              onClick={(): void => {
                if (disabled) return
                onChooseOption(option)
              }}
              disabled={disabled}
              key={option}
            >
              {option}
            </button>
          ))}
        </div>
      </div>
    </>
  )
}
